import React, { useState } from 'react';
import { NavLink, useNavigate, Outlet } from 'react-router-dom';
import { useAdmin } from '../context/AdminContext';
import './AdminLayout.css';

const NAV_ITEMS = [
  { to: '/admin/dashboard', icon: '📊', label: 'Dashboard' },
  { to: '/admin/products', icon: '🌱', label: 'Products' },
  { to: '/admin/sub-products', icon: '🧬', label: 'Sub Products' },
  { to: '/admin/content', icon: '🌍', label: 'Content & Languages' },
];

export default function AdminLayout() {
  const { adminUser, logout } = useAdmin();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className={`admin-layout ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="sidebar-brand">
          <span className="brand-icon">🌾</span>
          {sidebarOpen && <span className="brand-text">GangaSeed</span>}
        </div>

        <nav className="sidebar-nav">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              {sidebarOpen && <span className="nav-label">{item.label}</span>}
            </NavLink>
          ))}
        </nav>

        <button className="sidebar-logout" onClick={handleLogout}>
          <span className="nav-icon">🚪</span>
          {sidebarOpen && <span className="nav-label">Logout</span>}
        </button>
      </aside>

      {/* Main */}
      <div className="admin-main">
        {/* Topbar */}
        <header className="admin-topbar">
          <button className="toggle-btn" onClick={() => setSidebarOpen(!sidebarOpen)}>
            {sidebarOpen ? '◀' : '▶'}
          </button>
          <div className="topbar-title">GangaSeed Admin</div>
          <div className="topbar-right">
            <span className="admin-avatar">👤</span>
            <span className="admin-name">{adminUser}</span>
            <button className="topbar-logout-btn" onClick={handleLogout}>Logout</button>
          </div>
        </header>

        {/* Page Content */}
        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
